var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82579 5.2897L2.58579 1.0497C2.49283 0.955976 2.38223 0.881582 2.26037 0.830813C2.13851 0.780044 2.0078 0.753906 1.87579 0.753906C1.74378 0.753906 1.61307 0.780044 1.49122 0.830813C1.36936 0.881582 1.25876 0.955976 1.16579 1.0497C0.979542 1.23707 0.875 1.49052 0.875 1.7547C0.875 2.01889 0.979542 2.27234 1.16579 2.4597L4.70579 5.9997L1.16579 9.5397C0.979542 9.72707 0.875 9.98052 0.875 10.2447C0.875 10.5089 0.979542 10.7623 1.16579 10.9497C1.25923 11.0424 1.37005 11.1157 1.49189 11.1655C1.61372 11.2152 1.74419 11.2405 1.87579 11.2397C2.0074 11.2405 2.13786 11.2152 2.2597 11.1655C2.38154 11.1157 2.49235 11.0424 2.58579 10.9497L6.82579 6.7097C6.91952 6.61674 6.99391 6.50614 7.04468 6.38428C7.09545 6.26242 7.12159 6.13172 7.12159 5.9997C7.12159 5.86769 7.09545 5.73699 7.04468 5.61513C6.99391 5.49327 6.91952 5.38267 6.82579 5.2897Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/rightIcon.16087a1a61c4c3d721d7a3bb633b6c58.svg";
export { ForwardRef as ReactComponent };